import { AsyncPipe } from '@angular/common';
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { PayModeLevel1 } from '@fitness-force/enum';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
  selector: 'payment-mode',
  templateUrl: './payment-mode.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [AsyncPipe],
})
export class PaymentModeComponent {
  columnData: Observable<any> = new BehaviorSubject(null);
  additionData: Observable<any> = new BehaviorSubject(null);

  getMode(value: number, data: any) {
    if (!value || value == 0) return '-';
    else if (Object.keys(value).length == 0) {
      return '-';
    } else {
      if (PayModeLevel1[value] == PayModeLevel1[PayModeLevel1.Other]) {
        return data.paymodemst_name_pri_lang || '-';
      } else {
        return PayModeLevel1[value];
      }
    }
  }
}
